import * as React from 'react';
import Box from './box/Box';

const Page = (props: any) => {
    return <Box sx={{padding: 0}} {...props} />
}

export default Page;